import { getHeadingTag } from '@utils/heading';

import styles from './ProductFeature.module.css';

interface ProductFeatureProps {
	imageUrl: string;
	statement: string;
	headingLevel?: 1 | 2;
	padding?: 'xl' | 'xxl';
}

export const ProductFeature: React.VFC<ProductFeatureProps> = ({
	imageUrl,
	statement,
	headingLevel = 2,
	padding = 'xl',
}) => {
	const HeadingTag = getHeadingTag(headingLevel);
	const styleProperties = {
		'--inline-padding': padding === 'xl' ? 'var(--spacing-xl)' : '22.25rem',
		backgroundImage: `url(${imageUrl}?auto=format&q=60&w=2500`,
	} as React.CSSProperties;

	return (
		<>
			<div className={styles.transparent} />
			<section className={styles.section} style={styleProperties}>
				<HeadingTag className={`${styles.title} fluid-font-t1`}>
					{statement}
				</HeadingTag>
			</section>
		</>
	);
};
